
import NGError from '../../../error/ngError';
import errorFactory from '../../../error/errorFactory';
import {
	WS_PROCESS_MESSAGE_IS_MALFORMED,
} from '../../../error/websocket/errorTypes';
import { publishAndAwait } from '../../../app/coreSlice';

const listBanners = async (filter, page) => {
	const request = await publishAndAwait({
		destination: '/app/hello',
		body: {
			type: 'BANNER',
			subType: 'LIST_LOCATIONS',
			message: {
				filter,
				page,
			},
		},
	});

	const { processMessage, error } = request.response;

	if (!processMessage) {
		throw errorFactory(WS_PROCESS_MESSAGE_IS_MALFORMED);
	};

	if (error) {

		const {
			code,
			description,
			message,
			tag,
		} = processMessage;

		throw new NGError({
			message: description || message || tag,
			code,
			tag,
		});
	};

	return processMessage;
};

export default listBanners;